// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"818":"6f094dc7","9337":"6f094dc7"}[chunkId] + ".chunk.css";
};